var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeysetuptwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 24.9995C10.9255 24.9995 8.88655 24.4618 7.08195 23.4387C5.27736 22.4157 3.76879 20.9424 2.70343 19.1624C1.63808 17.3825 1.05233 15.3568 1.00335 13.283C0.954361 11.2091 1.44381 9.15804 2.42394 7.32979",
    stroke: "#7647EE",
    strokeWidth: 0.888883
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.999569C15.6151 0.999569 18.1586 1.85383 20.2435 3.43237C22.3284 5.01091 23.8406 7.22731 24.55 9.74434C25.2594 12.2614 25.1271 14.9412 24.1733 17.3762C23.2195 19.8111 21.4964 21.8678 19.2662 23.2334",
    stroke: "#7647EE",
    strokeWidth: 0.888883
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.9995,
    r: 10.2856,
    transform: "rotate(-90 13 12.9995)",
    fill: "#1E016F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49606 17.7139V16.6716C10.1178 16.1779 10.7121 15.6796 11.2789 15.1767C11.8458 14.6739 12.3486 14.1802 12.7875 13.6956C13.2355 13.2019 13.5875 12.7219 13.8435 12.2556C14.0995 11.7802 14.2275 11.3231 14.2275 10.8842C14.2275 10.5916 14.1772 10.3173 14.0766 10.0613C13.976 9.79621 13.8115 9.58592 13.5829 9.43049C13.3543 9.26592 13.048 9.18364 12.664 9.18364C12.088 9.18364 11.6538 9.36649 11.3612 9.73221C11.0778 10.0979 10.9406 10.5368 10.9498 11.0488H9.53721C9.54635 10.3722 9.68806 9.80535 9.96235 9.34821C10.2458 8.89107 10.6206 8.54364 11.0869 8.30593C11.5623 8.06822 12.0972 7.94936 12.6915 7.94936C13.5966 7.94936 14.3189 8.20536 14.8583 8.71736C15.4069 9.22021 15.6812 9.92421 15.6812 10.8293C15.6812 11.3688 15.5486 11.9036 15.2835 12.4339C15.0275 12.9642 14.6892 13.4762 14.2686 13.9699C13.8572 14.4545 13.4138 14.9116 12.9383 15.3413C12.4629 15.771 12.0103 16.1596 11.5806 16.507H15.9692V17.7139H9.49606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysetuptwo);
export default __webpack_public_path__ + "static/media/keysetuptwo.a3f16f134560f5b421ca33ba6cbc9f86.svg";
export { ForwardRef as ReactComponent };